import { useEffect } from "react";
import Reveal from "./Reveal";

export default function PageHeader({ eyebrow, title, sub, pageTitle }) {
  useEffect(() => {
    if (pageTitle) document.title = pageTitle;
  }, [pageTitle]);

  return (
    <header className="dot-grid border-b border-black/5">
      <div className="mx-auto max-w-7xl px-6 pb-12 pt-14 lg:px-12 lg:pb-16 lg:pt-20">
        <Reveal y={18}>
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-accent">{eyebrow}</span>
          <h1 className="mt-3 max-w-3xl font-display text-3xl font-black leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            {title}
          </h1>
          {sub && <p className="mt-4 max-w-2xl text-sm leading-relaxed text-neutral-600 sm:text-base">{sub}</p>}
        </Reveal>
      </div>
    </header>
  );
}
